import { useState, useRef, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isArray from 'lodash/isArray';

import { AuthContext } from 'context/AuthContext';
import { CustomToast } from 'components';
import { getRequestActionData } from '../methods';

export default function useRequestAction(
  osData = {},
  retexes = [],
  isCompact = false,
  isApproving = true,
  onBeforeProcessing = () => {},
  onSetProcessingId = () => {},
  onUpdateRetexData = () => {},
  onAfterProcessing = () => {}
) {
  const { push } = useHistory();
  const [isProcessing, setIsProcessing] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const { configuration } = useContext(AuthContext);
  const freezeRef = useRef(false);
  const apiResponseRef = useRef(null);

  const hasStoreAccess = _get(configuration, 'store.enabled', false);
  const hasWarehouseAccess = _get(configuration, 'warehouse.enabled', false);

  const {
    text,
    disabled,
    type,
    show,
    tooltipMessage,
    toastMessage,
    alertModalData,
    onTrigger
  } = getRequestActionData(
    osData,
    retexes,
    isCompact,
    isApproving,
    hasStoreAccess,
    hasWarehouseAccess,
    onSetProcessingId,
    onUpdateRetexData,
    push
  );

  useEffect(() => {
    if (!freezeRef.current && isProcessing && !_isEmpty(retexes)) {
      freezeRef.current = true;
      setIsUpdating(true);
      onTrigger().then(results => {
        apiResponseRef.current = results;
        setIsProcessing(false);
        onAfterProcessing();
      });
    }
  }, [isProcessing, retexes, onTrigger, onAfterProcessing]);

  useEffect(() => {
    if (isUpdating && !isProcessing) {
      const apiResponse = apiResponseRef.current;
      const reponseList = _isArray(apiResponse) ? apiResponse : [];
      const isError = reponseList.some(res => !!_get(res, 'error'));
      const isNotified = reponseList.some(res => !!_get(res, 'error.notified'));
      const toastType = isError ? 'error' : isApproving ? 'success' : 'info';
      const msg = _get(toastMessage, toastType, '');
      if (msg) CustomToast({ isNotified, msg, type: toastType });
      apiResponseRef.current = null;
      freezeRef.current = false;
      setIsUpdating(false);
    }
  }, [isProcessing, isApproving, isUpdating, toastMessage]);

  const onStartProcess = () => {
    const isProcessing = !['unlock', 'cancel'].includes(type);
    setIsProcessing(isProcessing);
    onBeforeProcessing(osData, type);
  };

  return {
    text,
    show,
    type,
    disabled,
    isProcessing,
    tooltipMessage,
    alertModalData,
    onStartProcess
  };
}
